'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TestimonialSidebar = require('./TestimonialSidebar.styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TestimonialSidebar = function (_React$PureComponent) {
  _inherits(TestimonialSidebar, _React$PureComponent);

  function TestimonialSidebar() {
    _classCallCheck(this, TestimonialSidebar);

    return _possibleConstructorReturn(this, (TestimonialSidebar.__proto__ || Object.getPrototypeOf(TestimonialSidebar)).apply(this, arguments));
  }

  _createClass(TestimonialSidebar, [{
    key: 'createMessage',
    value: function createMessage() {
      return { __html: this.props.message };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _TestimonialSidebar.Wrapper,
        null,
        _react2.default.createElement(
          _TestimonialSidebar.ImageContainer,
          null,
          _react2.default.createElement(_TestimonialSidebar.Image, { src: this.props.image })
        ),
        _react2.default.createElement(_TestimonialSidebar.Message, { dangerouslySetInnerHTML: this.createMessage() }),
        _react2.default.createElement(
          _TestimonialSidebar.Author,
          null,
          this.props.author
        ),
        _react2.default.createElement(
          _TestimonialSidebar.Position,
          null,
          this.props.position
        ),
        this.props.logo && _react2.default.createElement(_TestimonialSidebar.Logo, { src: this.props.logo })
      );
    }
  }]);

  return TestimonialSidebar;
}(_react2.default.PureComponent);

TestimonialSidebar.propTypes = {
  image: _propTypes2.default.string.isRequired,
  logo: _propTypes2.default.string,
  message: _propTypes2.default.string.isRequired,
  author: _propTypes2.default.string.isRequired,
  position: _propTypes2.default.string.isRequired
};
exports.default = TestimonialSidebar;
module.exports = exports['default'];